import { api } from './index';

export interface TenderItem {
  id: string;
  tenderId: string;
  itemName: string;
  description?: string;
  quantity: number;
  unit: string;
  order: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateTenderItemDto {
  itemName: string;
  description?: string;
  quantity: number;
  unit: string;
  order: number;
}

export interface UpdateTenderItemDto extends Partial<CreateTenderItemDto> {}

export const tenderItemsApi = {
  // Create tender item
  createTenderItem: async (tenderId: string, data: CreateTenderItemDto): Promise<TenderItem> => {
    const response = await api.post(`/tenders/${tenderId}/items`, data);
    return response.data;
  },

  // List tender items (admin endpoint)
  listTenderItems: async (tenderId: string): Promise<TenderItem[]> => {
    const response = await api.get(`/tenders/${tenderId}/items`);
    return response.data;
  },

  // List tender items (vendor endpoint)
  listVendorTenderItems: async (tenderId: string): Promise<TenderItem[]> => {
    const response = await api.get(`/vendors/tenders/${tenderId}/items`, {
      useVendorAuth: true, // Explicitly use vendor authentication
    });
    return response.data;
  },

  // Get tender item by ID
  getTenderItemById: async (tenderId: string, itemId: string): Promise<TenderItem> => {
    const response = await api.get(`/tenders/${tenderId}/items/${itemId}`);
    return response.data;
  },

  // Update tender item
  updateTenderItem: async (tenderId: string, itemId: string, data: UpdateTenderItemDto): Promise<TenderItem> => {
    const response = await api.put(`/tenders/${tenderId}/items/${itemId}`, data);
    return response.data;
  },

  // Remove tender item
  removeTenderItem: async (tenderId: string, itemId: string): Promise<void> => {
    await api.delete(`/tenders/${tenderId}/items/${itemId}`);
  },
};
